import classNames from "classnames";
import _ from "lodash";
import React from "react";
import { Error, LabelChildren } from "../Forms/FormFieldInputNew";
import { ErrorTypeEnum } from "../Forms/formUtil";
import { Formidable } from "./../../";
import Select from "./Select";
import styles from "./Select.module.scss";

const FormFieldSelect = React.memo(React.forwardRef(({
    isOptional, label, labelChildren, useLabelMargin, bottomMargin = true,
    type, name, onChange, value, errorMessage, showError, errorType = ErrorTypeEnum.ERROR, isDisabled, disabled,
    inputChildren, inputButtons, inputChildrenClassName, inputChildrenStyle, isOpened = false, onOpenOrClose = _.noop,
    className, style, inputStyle, labelStyle, inputClassName, labelClassName,
    errorClassName, errorStyle, isSummaryView = false,
    pending, showSecondaryLabelInSelectedOption,
    placeholder, isLoading, noOptionsMessage,
    options, isClearable, menuPortalTarget, isSearchable, isMulti, isRequireAcceptOnChange, isCreatable, dataTestId, hasSelectAll = false,
    isReadOnly, ...rest
}, ref) => {
    const hasError = showError && errorMessage && errorType === ErrorTypeEnum.ERROR;
    if (_.isUndefined(isDisabled) && disabled === true) {
        isDisabled = true;
    }

    return <div className={classNames(styles.base, { [styles['margin-bottom']]: bottomMargin }, className)} style={style} ref={ref} data-testid={dataTestId && `${dataTestId}-wrapper`}>
        <LabelChildren disabled={isDisabled} isOptional={isOptional} labelChildren={labelChildren} />
        <label className={classNames({ [styles["disabled"]]: disabled })}>
            {label && <span className={classNames(labelClassName, styles["label"])} style={labelStyle}>{label}</span>}
            {useLabelMargin && <span className={classNames(labelClassName, styles["label"])} style={labelStyle}>&nbsp;</span>}
            <Select
                placeholder={placeholder}
                value={value}
                isOpened={isOpened}
                onOpenOrClose={onOpenOrClose}
                isLoading={isLoading}
                isSummaryView={isSummaryView}
                showSecondaryLabelInSelectedOption={showSecondaryLabelInSelectedOption}
                isDisabled={isDisabled}
                options={options}
                isClearable={!isRequireAcceptOnChange && isClearable}
                onChange={onChange}
                name={name}
                hasError={hasError}
                menuPortalTarget={menuPortalTarget}
                isSearchable={isSearchable || isCreatable}
                isMulti={isMulti}
                noOptionsMessage={noOptionsMessage}
                isRequireAcceptOnChange={isRequireAcceptOnChange}
                isCreatable={isCreatable}
                dataTestId={dataTestId}
                hasSelectAll={hasSelectAll}
                isReadOnly={isReadOnly}
            />
        </label>
        <Error
            showError={showError}
            errorClassName={errorClassName}
            errorStyle={errorStyle}
            errorType={errorType}
            errorMessage={errorMessage}
            dataTestId={dataTestId && `${dataTestId}-error`}
        />
    </div>
}))

export default React.forwardRef((props, ref) => {
    return <Formidable {...props} ref={ref} Component={FormFieldSelect} />
});
